import {
  Component,
  OnInit,
  Input,
  OnChanges,
  ViewChild,
  Inject,
  PipeTransform,
  Pipe,
  ElementRef,
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { MatMenuTrigger } from '@angular/material/menu';
import { DomSanitizer } from '@angular/platform-browser';
import { User } from '../../models/user';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../../environments/environment';
import { JWTService } from '../../services/jwt.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { SessionStorageService } from '../../services/session-storage.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../../services/local-storage.service';
import { FeedbackPopupDialog } from '../feedback-popup/feedback-popup.component';
import { KeycloakService } from 'keycloak-angular';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from '../../services/header.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;
  @ViewChild('pdfTable')
  pdfTable!: ElementRef;
  //private _currentUser:User|null = null
  @Input()
  headerText: string = '';
  version = environment.version;
  role: string = '';
  isUser: any;
  activeNotification: any;
  // get currentUser() {
  //   return this._currentUser
  // }

  // @Input()
  // set currentUser(val:User|null) {

  //   this._currentUser = val;
  //   if(val && val.isAuthenticated) {
  //     this.isAuthenticated = true
  //   }
  //   else{
  //     this.isAuthenticated = false
  //   }
  // }

  // isAuthenticated:boolean = false

  @Input()
  isNew;
  data: any;
  downloadLink: any;
  user = '';
  path:any
  userProfile: any;
  ver;
  baseVersions: any;
  constructor(
    private keycloakService: KeycloakService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private auth: AuthService,
    public dialog: MatDialog,
    private localService: LocalStorageService,
    private router: Router,
    private route: ActivatedRoute,
    private headerService: HeaderService
  ) {
    console.log(1);
    this.path=window.location.pathname
    if(this.path=='/ebu/engines/sales-realization/industrial'){ this.version=environment.version1}
    if(this.path=='/ebu/engines/sales-realization/All'){ this.version=environment.version1}
    if(this.path=='/ebu/engines/sales-realization/onHighway'){ this.version=environment.version1}
    if(this.path=='/ebu/engines/sales-realization/powerGen'){ this.version=environment.version1}
    if(this.path=='/distribution/cssna/powerGen/powerGen'){ this.version=environment.version2}
    if(this.path=='/distribution/cssna/engines/industrial'){ this.version=environment.version2}
    if(this.path=='/distribution/international/parts'){ this.version=environment.version2}
    if(this.path=='/distribution/cssna/engines/on-highway'){ this.version=environment.version2}
    if(this.path=='/distribution/international/parts/AME'){ this.version=environment.version2}
    if(this.path=='/distribution/international/parts/Arabia-JV'){ this.version=environment.version2}
    if(this.path=='/distribution/international/parts/Asia-Pacific'){ this.version=environment.version2}
    if(this.path=='/distribution/international/parts/East-Asia'){ this.version=environment.version2}
    if(this.path=='/distribution/international/parts/Greater-Europe'){ this.version=environment.version2}
    if(this.path=='/distribution/international/parts/India'){ this.version=environment.version2}
    if(this.path=='/distribution/international/parts/Latin-America'){ this.version=environment.version2}
    if(this.path=='/power-systems/engines/sales-realization'){ this.version=environment.version3}
    if(this.path=='/power-systems/power-gen/sales-realization'){ this.version=environment.version3}
    if(this.path=='/power-systems/parts/psbu'){ this.version=environment.version5}
    if (this.path == '/distribution/dbu_overall') { this.version = environment.version2 }
    if(this.path=='/overall/overall-view'){ this.version=environment.version4}
    if(this.path=='/ebu/parts/ebu'){ this.version=environment.version5}
    if(this.path=='/components/ctt/parts'){ this.version=environment.version5}
    if(this.path=='/power-systems/margin-realization'){ this.version=environment.version3}
    if(this.path === '/components/meritor') {
      this.version = environment.meritorDateOfUpdate
    }
    if(this.path === '/valvetrain') {
      this.version = environment.version1
    }
    if(this.path === '/software-electronics') {
      this.version = environment.version1
    }
    if(this.path === '/fuel-systems') {
      this.version = environment.version1
    }

    console.log(this.path);
    this.matIconRegistry.addSvgIcon(
      `logout`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `/assets/images/logout.svg`
      )
    );
    this.matIconRegistry.addSvgIcon(
      `help`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `/assets/images/help.svg`
      )
    );
  }

  ngOnInit(): void {
    this.auth.currentNotification.subscribe((notification) => {
      this.activeNotification = notification;
    });
    this.user = this.keycloakService.getUsername();

    this.path = this.route.url;

    this.keycloakService.loadUserProfile().then(profile => {
      this.userProfile = profile;
    });

    this.headerService.getVersions().subscribe((res) => {
      this.baseVersions = res;
      this.updateVersionText(window.location.pathname);
    });

    this.router.events.subscribe((event: any) => {
      if (event && event.urlAfterRedirects) {
        if (this.baseVersions) {
          this.updateVersionText(event.urlAfterRedirects);
        }
      } else if (event && event.url) {
        if (this.baseVersions) {
          this.updateVersionText(event.url);
        }
      }
    });
  }

  updateVersionText(currentPath: string) {
    this.path = currentPath;
    let baseVer = this.baseVersions;
    
    // Original logic to select the branch
    if (
        this.path.includes('/ebu/engines/sales-realization/industrial') ||
        this.path.includes('/ebu/engines/sales-realization/All') ||
        this.path.includes('/ebu/engines/sales-realization/onHighway') ||
        this.path.includes('/ebu/engines/sales-realization/powerGen')
      ) {
        baseVer = this.baseVersions['ebu'];
      }

    if (
      this.path.includes('/distribution/cssna/powerGen/powerGen') ||
      this.path.includes('/distribution/cssna/engines/industrial') ||
      this.path.includes('/distribution/international/parts') ||
      this.path.includes('/distribution/cssna/engines/on-highway') ||
      this.path.includes('/distribution/international/parts/AME') ||
      this.path.includes('/distribution/international/parts/Arabia-JV') ||
      this.path.includes('/distribution/international/parts/Asia-Pacific') ||
      this.path.includes('/distribution/international/parts/East-Asia') ||
      this.path.includes('/distribution/international/parts/Greater-Europe') ||
      this.path.includes('/distribution/international/parts/Latin-America') ||
      this.path.includes('/distribution/international/parts/India') ||
      this.path.includes('/distribution/international/overall') ||
      this.path.includes('/distribution/dbu_overall')
    ) {
      baseVer = this.baseVersions['distribution'];
    }

      if (
        this.path.includes('/power-systems/engines/sales-realization') ||
        this.path.includes('/power-systems/margin-realization')
      ) {
        baseVer = this.baseVersions['power_unit_engine'];
      }
      if (this.path.includes('/power-systems/power-gen/sales-realization')) {
        baseVer = this.baseVersions['power_unit_genset'];
      }
      if (
        this.path.includes('/power-systems/parts/psbu') ||
        this.path.includes('/ebu/parts/ebu') ||
        this.path.includes('/components/ctt/parts') ||
        this.path.includes('/ces-after-market')
      ) {
        baseVer = this.baseVersions['nrp'];
      }
      if (this.path.includes('/overall/overall-view')) {
        baseVer = this.baseVersions['overall'];
      }

      if (this.path.includes('/components/meritor')) {
        baseVer = this.baseVersions['component_meritor_cdbs'];
      }
      if (this.path.includes('/cec-ctt-first-fit')) {
        baseVer = this.baseVersions['component_first_fit'];
      }
      if (this.path.includes('/valvetrain')) {
        baseVer = this.baseVersions['valvetrain'];
      }
      if (this.path.includes('/software-electronics')) {
        baseVer = this.baseVersions['electronics'];
      }
      if (this.path.includes('/fuel-systems')) {
        baseVer = this.baseVersions['fuel_systems'];
      }

      this.ver = baseVer;

      const pageName = this.getPageName(this.path);
      if (pageName && this.ver && typeof this.ver === 'string') {
         this.ver = this.ver + ' - ' + pageName;
      }
  }

  getPageName(path: string): string {
    const segments = path.split('?')[0].split('/').filter(s => s.length > 0);
    if (segments.length === 0) return '';
    const lastSegment = segments[segments.length - 1];
    
    const pageNameMap: { [key: string]: string } = {
       'All': 'All',
       'industrial': 'Industrial',
       'onHighway': 'On Highway',
       'on-highway': 'On Highway',
       'powerGen': 'Power Gen',
       'detailed-sales': 'Detailed Sales Realization',
       'sales-contribution': 'Contribution to Sales',
       'deep-dive': 'Deep Dive',
       'deep-down': 'Deep Dive',
       'summary': 'Summary',
       't-chart': 'T Chart',
       'wave-initiative': 'Wave Initiative',
       'regional-summary': 'Regional Summary',
       'sales-realization': 'Sales Realization',
       'margin-realization': 'Margin Realization',
       'psbu': 'PSBU',
       'ebu': 'EBU',
       'parts': 'Parts',
       'AME': 'AME',
       'Arabia-JV': 'Arabia JV',
       'Asia-Pacific': 'Asia Pacific',
       'East-Asia': 'East Asia',
       'Greater-Europe': 'Greater Europe',
       'Latin-America': 'Latin America',
       'India': 'India',
       'valvetrain': 'Valvetrain',
       'software-electronics': 'Software & Electronics',
       'fuel-systems': 'Fuel Systems',
       'jacobs-vehicle-systems': 'Jacobs Vehicle Systems',
       'ces-first-fit': 'CES First Fit',
       'ces-after-market': 'CES After Market',
       'cec-ctt-first-fit': 'CTT First Fit',
       'cec-cfs-first-fit': 'CFS First Fit',
       'meritor': 'Meritor',
       'customerLevel': 'Customer Level',
       'overall-view': 'Overall View',
       'dbu_overall': 'DBU Overall'
    };

    if (pageNameMap[lastSegment]) {
      return pageNameMap[lastSegment];
    }
    
    // generic fallback formatted nicely
    let formatted = lastSegment.replace(/-/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2');
    formatted = formatted.split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
    // replace url encoding
    try {
        return decodeURIComponent(formatted);
    } catch {
        return formatted;
    }
  }

  typeOf(value) {
    return typeof value;
  }

  // TODO : dummy function to prevent click
  noLink(event: any) {
    event.preventDefault();
  }

  onLogout(e: any) {
    e.preventDefault();
    e.stopPropagation();
    this.keycloakService.logout(environment.url);
  }

  // openDialog() {
  //   const dialogRef = this.dialog.open(HelpComponent, {});
  //   dialogRef.afterClosed().subscribe((result) => {});
  // }

  openDialog() {
    const page = this.router.url;
    const videoUrl = this.headerService.getVideoUrl(page);
    const dialogRef = this.dialog.open(HelpComponent, {
      data: { videoUrl, page },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }
  openFeedback() {
    const dialogRef = this.dialog.open(FeedbackPopupDialog, {
      width: '500px',
      height: '500px',
    });
  }
}

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HelpComponent {
   // videoUrl = 'http://3.82.111.82:8080/api/video/stream/mp4/springboot';
  // API_URL = environment.API_URL;
  // videoUrl = `${this.API_URL}/api/video/stream/1/mp4/vinay`;
  finalVideoUrl: any;
  constructor( 
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private http: HttpClient,
    private dialogRef: MatDialogRef<HelpComponent>,
    private headerService: HeaderService
  ) {
    const page = data.page;
    console.log('Page:', page);
    const videoUrl = this.headerService.getVideoUrl(page);
    console.log('Video URL:', videoUrl);
    const token = this.authService.getCurrentUser();
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    this.http
      .get(videoUrl, { headers, responseType: 'blob' })
      .subscribe((response) => {
        const reader = new FileReader();
        const promise = new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(response);
          reader.onload = function (e) {
            resolve(reader.result);
          };
        });
        promise.then((img) => {
          this.finalVideoUrl = img;
        // if you want to do anything with img you can do it here

        });
      });
  }
  ngOnInit() {}
}

@Pipe({
  name: 'authVideo',
})

export class AuthVideoPipe implements PipeTransform {
  constructor(
    private http: HttpClient,
    private jwt: JWTService,
    private authService: AuthService
  ) {}

  transform(url: string) {
    return new Observable<string>((observer) => {
      const token = this.authService.getCurrentUser();
      const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
      const { next, error } = observer;
      return this.http
        .get(url, { headers, responseType: 'blob' })
        .subscribe((response) => {
          const reader = new FileReader();
          reader.readAsDataURL(response);
          reader.onloadend = function (fileLoad) {
            observer.next(reader.result as string);
          };
        });
    });
  }
}